import {IUITipoDePontuacaoLoja} from "./IUITipoDePontuacaoLoja";


export class IUITipoDePontuacaoQtdeVariavelAtividade implements IUITipoDePontuacaoLoja {
  constructor(private empresa: any, private tipoDePontuacao: any, private tipoDeAcumulo: string, private atividade: any) {
  }

  calculePontos(valorVenda: number, itens: any) {
    if(itens && itens.length)
      return itens.reduce((soma: number, item: any) =>  soma + (  item.obtenhaPontosFidelidade(this.atividade)), 0)

    return this.atividade.pontosGanhos;
  }

  obtenhaPontosFormatado(valorVenda: number, itens: any) {
    let pontos = this.calculePontos(valorVenda, itens)

    if(this.tipoDeAcumulo === 'Reais')
      return    String(`R$ ${pontos.toFixed(2).replace('.', ',')}`)


    return String(`${pontos > 0 ? pontos : ''} ${pontos  <= 1 ? 'Selo' : "Selos" }`)
  }

}
